import {ONEPALINK} from '../libs/messages';
const Footer = () => {
  return <div className={`container app-footer mt-4`}>
    <div className="row">
      <div className="col-md-12 text-center">
        <div className="app-footer-body">
          <p>Click <a href={ONEPALINK} rel="noreferrer"
                   target='_blank'> here</a> to
          find out more about the<br/>
          PAssion CARES initiative. T&amp;Cs apply.
          </p>
          <div className="powered-by">
            <div className="footer-text-powered">Powered by</div>
            <div className="footer-powered-by-logo">
            <img src='https://www.gevme.com/file/location/public/logo/Gevme-logo-Full%20colour-80-x-20.png
' alt="" />            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
};

export default Footer;